import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  HeaderComponent,
  EmployeeWithProfile,
  PaginationComponent
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { Commons, Const, colors } from "../../constants";
import { Badge, message } from 'antd';
import { FilterComponent, FilterButton } from "@comps/components";
import { deleteDataReq, getAllDataReq, getFilterReq } from "./requests";
import { useSelector } from "react-redux";
import CreateCompanyTravelReq from "./components/CreateCompanyTravelReq";
import ViewRequestHistory from '@mods/common/ViewRequestHistory';
import ViewFlow from '@mods/common/ViewFlow';
import UpdateCompanyTravelReq from "./components/UpdateCompanyTravelReq";
import { getRequestFilters } from "@mods/common/commonFilterFields";
import { useLocation } from "react-router-dom";


const langKey = Const["companyTravel"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.listName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.listName`),
        path: Const["companyTravel"].route
      }
    ]
  }
}

const IndexCompanyTravelReq = (props) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [allData, setAllData] = useState({})
  const [filters, setFilters] = useState('');

  //start pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });
  //end pagination states

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================

  const columns = [
    // {
    //   key: 'code',
    //   title: trans(Commons.code),
    //   dataIndex: "code",
    // },
    {
      key: 'employee_id',
      title: trans(`${langKey}.employee_id`),
      render: (record) => {
        return <EmployeeWithProfile record={ record.requestor } />
      },
    },
    {
      key: 'next_requestee',
      title: trans(`${langKey}.next_requestee`),
      render: (record) => {
        return <EmployeeWithProfile record={ record.next_requestee_name } />
      },
    },
    {
      key: 'status',
      title: trans(`${langKey}.status`),
      render: (record) => {
        return <Badge
          count={ record.status ? record.status : 'none' }
          style={ { background: colors[record.status_class], color: colors[record.status_class + '-color'] } }
        />
      }
    },
    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onViewHistory={ record.status !== 'Pending' ? onViewHistory : '' }
          onViewFlow={ record.flow.length !== 0 ? onViewFlow : '' }
          onEdit={ record.status === 'Pending' ? onEdit : '' }
          onView={ onView }
          onDelete={ record.status === 'Pending' ? onDelete : '' }

        >
        </ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  const location = useLocation();
  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [location.pathname, filters, currentPage]);
  const getAllData = () => {
    let payload = {
      page: currentPage,
      filters: props.filters + ';' + filters
    }
    setChildComponent(null)
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, onGetAllDataError);
  };
  const onSuccess = (response) => {
    setAllData(response)
    setPagination(response.travels);
    setDataSource(response.travels.data);
  };
  const onGetAllDataError = (err, res) => {
    message.error(res.response.data.message);
  }
  const onEdit = (record) => {
    setChildComponent(<UpdateCompanyTravelReq onCompleted={ onCompleted } authUser={ authUser } travel_types={ allData.travel_types } travel_modes={ allData.travel_modes } stay_types={ allData.stay_types } record={ record } disabled={ false } filters={ props.filters } />);
  };
  const onView = (record) => {

    setChildComponent(<UpdateCompanyTravelReq onCompleted={ onCompleted } authUser={ authUser } travel_types={ allData.travel_types } travel_modes={ allData.travel_modes } stay_types={ allData.stay_types } record={ record } disabled={ true } />);
  };

  const onViewHistory = (record) => {
    setChildComponent(
      <ViewRequestHistory onCompleted={ onCompleted } record={ record } disabled={ true } subTitle={ trans(Commons.history) } />
    );
  };
  const onViewFlow = (record) => {
    setChildComponent(
      <ViewFlow onCompleted={ onCompleted } record={ record } disabled={ true } subTitle={ trans(Commons.flow) } />
    );
  };
  const onDelete = (record) => {
    const payload = {
      filters: '', id: record.id
    }
    makeRequest(setLoader, deleteDataReq, payload, onDeleted, onError);
  };
  const onDeleted = (res) => {
    onSuccess(res)
    setDataSource(res.travels.data);

    message.success("Record Deleted")
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  // Create component modal
  const onCreate = () => {
    setChildComponent(<CreateCompanyTravelReq onCompleted={ onCompleted } authUser={ authUser } travel_types={ allData.travel_types } travel_modes={ allData.travel_modes } stay_types={ allData.stay_types } onSuccess={ onSuccess } module={ props.module } filters={ props.filters } />);
  };

  const onCompleted = (data) => {
    if (data.length) {
      setDataSource(data);
    }
    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);
  }

  //----end filter--------------------

  return (
    <>

      { childComponent }
      <BodyComponent>
        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
          <RefreshButton onClick={ getAllData } /> <CreateButton onClick={ onCreate } />
          <FilterButton onClick={ onOpenFilter } />
        </HeaderComponent>
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
        />
      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );
};

export default IndexCompanyTravelReq;
const filterFields = getRequestFilters('')
